(() => {
	/** @param {HTMLElement} header @param {HTMLButtonElement} button */
	const closeMenu = (header, button) => {
		header.dataset.menuOpen = "false";
		button.setAttribute("aria-expanded", "false");
		const label = button.querySelector(".visually-hidden");
		if (label) label.textContent = "Menü öffnen";
	};

	document.querySelectorAll(".stampf-site-header").forEach((header) => {
		if (!(header instanceof HTMLElement)) return;
		const button = header.querySelector(".stampf-site-header__menu-button");
		const menu = header.querySelector(".stampf-site-header__links");
		if (!(button instanceof HTMLButtonElement) || !menu) return;

		button.addEventListener("click", () => {
			const open = header.dataset.menuOpen === "true";
			header.dataset.menuOpen = String(!open);
			button.setAttribute("aria-expanded", String(!open));
			const label = button.querySelector(".visually-hidden");
			if (label) label.textContent = open ? "Menü öffnen" : "Menü schließen";
		});

		menu.addEventListener("click", (event) => {
			if (event.target instanceof HTMLAnchorElement) closeMenu(header, button);
		});

		document.addEventListener("keydown", (event) => {
			if (event.key === "Escape") closeMenu(header, button);
		});
	});
})();
